module.exports = __webpack_public_path__ + "gallery-uploads-empty-state.572886ba9d999eaaea5dcc04c78e8991.png";